import React, { Component } from "react";
import Header from "../../../../layout/Header";
import Sidebar from "../../../../layout/Sidebar";
import { message, Spin, Input, Select, Button } from "antd";
import Bridge from "../../../../constants/Bridge";
import { DEMOGRAPHIC_SELECT_LIST } from "../../../../constants/consts";
import moment from "moment";
import $ from "jquery";

const { Option } = Select;
class ViewDemographics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      middleName: "",
      dob: "",
      placeOfBirth: "",
      currentResidence: "",
      maritalStatus: "",
      residenceType: "",
      residenceOtherSpecification: "",
      physicalGenderBirth: "",

      race: "",
      raceOtherSpeicification: "",
      ethnicity: "",
      isEnglishLanguage: "",
      otherLangage: "",
      usRegion: "",
      highelLevelOfEducation: "",
      otherHighestEducation: "",
      occupation: "",
      totalHouseIncome: "",
      dominantHand: "",
      heightInInch: "",
      heightInFeet: "",
      weight: "",
      smokingHistory: "",
      haveQuiteSmoking: "",
      participant_id: "",
      loading: false,
      prescriptions: [],
      prescriptionText: "",
      allergyText: "",
      allergies: [],
      adhd_add: "",
      anxiety: "",
      bipolarDisorder: "",
      brainAneurysm: "",
      cancer: "",
      concussion: "",
      cognitiveImpairment: "",
      dementia: "",
      depression: "",
      diabetes: "",
      epilepsy: "",
      muscleDisease: "",
      schizophrenia: "",
      diagnosis: "",
      diagnosisALS: "",
      diagnosisOther: "",
      physicianName: "",
      hospitalName: "",
      hospitalCity: "",
      dateOfDiagnosis: "",
      c9orfMutatio: "",
      dateOfSymptom: "",
      siteOfSymptomOnset: "",
      siteOfSymptomOnsetForBulbar: "",
      siteOfSymptomOnsetForLimb: "",
      siteOfSymptomOnsetOtherSpecification: "",
      positiveHistory: "",
      positiveHistoryIfYesValue: "",
      diagnosedWithhearLoss: "",
      receivedTheoropy: "",
      applyToYou: "",
      coldNow: "",
      hospitalizedInLast3month: "",
      typeOfShoes: "",
      typeOfOrthotics: "",
      typeOfOrthoticsList: [],
      dimensions: "",
      haveStairAtHome: "",
      // if stair at home equal to yes
      howStairsAre: "",
      flooringOfYourStairs: "",
      howManySteps: "",
      heightOfStep: "",
      neurostamp_id: "",
      dateofbirth_error: false,
      dateofsymptomerror: false,
      dateodiagnosiserror: false,
      totalhouseholderror: false,
      otherInputLanguage: "",
      participant_id: "",
    };
  }
  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    const paramValue = searchParams.get("neurostamp_id");
    if (paramValue) {
      this.setState(
        {
          neurostamp_id: paramValue,
        },
        () => this.get_demographics_list(paramValue)
      );
    } else {
      window.location.assign("/participants/radcliff");
      return;
    }
  }
  // get demographics details
  get_demographics_list = (neurostamp_id) => {
    let params = "?neurostamp_id=" + neurostamp_id;
    this.setState({ loading: true });
    Bridge.participants
      .get_radcliff_demographic_details(params)
      .then((res) => {
        if (res.status == "1") {
          if (res.data.length > 0) {
            this.setState({
              neurostamp_id: res.data[0].neurostamp_id,
            });
            for (let item of res.data) {
              if (item.field == "FirstName") {
                this.setState({ firstName: item.value });
              }
              if (item.field == "MiddleName") {
                this.setState({ middleName: item.value });
              }
              if (item.field == "LastName") {
                this.setState({ lastName: item.value });
              }
              if (item.field == "City, State and Country of birth") {
                this.setState({ placeOfBirth: item.value });
              }
              if (item.field == "City, State and Country of Residence") {
                this.setState({ currentResidence: item.value });
              }
              if (item.field == "Marital status") {
                this.setState({ maritalStatus: item.value });
              }
              if (item.field == "Residence Type") {
                console.log("residenceType", item.value);
                this.setState({ residenceType: item.value });
              }
              if (item.field == "other residence type") {
                this.setState({ residenceOtherSpecification: item.value });
              }
              if (item.field == "Physical gender at birth") {
                this.setState({ physicalGenderBirth: item.value });
              }
              if (item.field == "Race") {
                this.setState({ race: item.value });
              }
              if (item.field == "other race") {
                this.setState({ raceOtherSpeicification: item.value });
              }
              if (item.field == "Ethnicity") {
                this.setState({ ethnicity: item.value });
              }
              if (item.field == "Is English your first language?") {
                this.setState({ isEnglishLanguage: item.value });
              }
              if (
                item.parent_field == "Is English your first language?" &&
                item.field == "No"
              ) {
                this.setState({ otherLangage: item.value });
              }
              if (item.field == "other language") {
                this.setState({ otherInputLanguage: item.value });
              }
              if (
                item.field ==
                "Which region in the United States do you consider yourself from?"
              ) {
                this.setState({ usRegion: item.value });
              }
              if (item.field == "Highest level of Education") {
                this.setState({ highelLevelOfEducation: item.value });
              }
              if (item.field == "other education") {
                this.setState({ otherHighestEducation: item.value });
              }
              if (item.field == "What is your occupation?") {
                this.setState({ occupation: item.value });
              }
              if (item.field == "Total Household Income") {
                this.setState({ totalHouseIncome: item.value });
              }
              if (item.field == "What is your dominant hand?") {
                this.setState({ dominantHand: item.value });
              }
              if (item.field == "HeightFeet") {
                this.setState({ heightInFeet: item.value });
              }
              if (item.field == "HeightInch") {
                this.setState({ heightInInch: item.value });
              }
              if (item.field == "Weight") {
                this.setState({ weight: item.value });
              }
              if (item.field == "Smoking History") {
                this.setState({ smokingHistory: item.value });
              }
              if (item.field == "Have you quit smoking in the past year?") {
                this.setState({ haveQuiteSmoking: item.value });
              }
              if (item.field == "Please List Specific Allergies") {
                if (item.value != "") {
                  let temp = JSON.parse(item.value);
                  // console.log("Allergies", temp);
                  this.setState({ allergies: temp });
                }
              }
              if (item.field == "What are your current prescriptions") {
                if (item.value != "") {
                  let temp2 = JSON.parse(item.value);
                  // console.log("prescriptions", temp2);
                  this.setState({ prescriptions: temp2 });
                }
              }
              if (item.field == "ADHD/ADD") {
                this.setState({ adhd_add: item.value });
              }
              if (item.field == "Anxiety") {
                this.setState({ anxiety: item.value });
              }
              if (item.field == "Bipolar disorder") {
                this.setState({ bipolarDisorder: item.value });
              }
              if (item.field == "Brain Aneurysm") {
                this.setState({ brainAneurysm: item.value });
              }
              if (item.field == "Cancer") {
                this.setState({ cancer: item.value });
              }
              if (item.field == "Concussion (s)") {
                this.setState({ concussion: item.value });
              }
              if (item.field == "Cognitive Impairment") {
                this.setState({ cognitiveImpairment: item.value });
              }
              if (item.field == "Dementia") {
                this.setState({ dementia: item.value });
              }
              if (item.field == "Depression") {
                this.setState({ depression: item.value });
              }
              if (item.field == "Diabetes") {
                this.setState({ diabetes: item.value });
              }
              if (item.field == "Epilepsy") {
                this.setState({ epilepsy: item.value });
              }
              if (item.field == "Muscle Disease") {
                this.setState({ muscleDisease: item.value });
              }
              if (item.field == "Schizophrenia") {
                this.setState({ schizophrenia: item.value });
              }
              if (item.field == "Diagnosis") {
                this.setState({ diagnosis: item.value });
              }
              if (item.field == "ALS") {
                this.setState({ diagnosisALS: item.value });
              }
              if (item.field == "Any other Neurologic diagnosis") {
                this.setState({ diagnosisOther: item.value });
              }
              if (item.field == "Your Neurologist or Physician name") {
                this.setState({ physicianName: item.value });
              }
              if (item.field == "Clinic or Hospital name") {
                this.setState({ hospitalName: item.value });
              }
              if (item.field == "Clinic or Hospital city") {
                this.setState({ hospitalCity: item.value });
              }
              if (item.field == "Date Of Diagnosis") {
                this.setState({
                  dateOfDiagnosis: item.value
                    ? moment(item.value).format("YYYY-MM-DD")
                    : "",
                });
              }
              if (item.field == "C9ORF mutation") {
                this.setState({ c9orfMutatio: item.value });
              }
              if (item.field == "Date of Symptom Onset") {
                this.setState({
                  dateOfSymptom: item.value
                    ? moment(item.value).format("YYYY-MM-DD")
                    : "",
                });
              }
              if (item.field == "Site of Symptom Onset") {
                this.setState({ siteOfSymptomOnset: item.value });
              }
              if (
                item.parent_field == "Site of Symptom Onset" &&
                item.field == "Limb"
              ) {
                this.setState({ siteOfSymptomOnsetForLimb: item.value });
              }
              if (
                item.parent_field == "Site of Symptom Onset" &&
                item.field == "Bulbar"
              ) {
                this.setState({ siteOfSymptomOnsetForBulbar: item.value });
              }
              if (item.field == "other symptoms") {
                this.setState({
                  siteOfSymptomOnsetOtherSpecification: item.value,
                });
              }
              if (
                item.field ==
                "Do you have a positive family history for ALS or any other neurodegenerative disease (Frontotemporal Dementia, Parkinson’s Disease, Altzheimer’s Disease)?"
              ) {
                this.setState({
                  positiveHistory: item.value,
                });
              }
              if (
                item.field ==
                ", please indicate the relationship (mother, father, sibling etc…), the disease, and the approximate age of onset of disease symptoms"
              ) {
                this.setState({
                  positiveHistoryIfYesValue: item.value,
                });
              }
              if (item.field == "Have you been diagnosed with hearing loss?") {
                this.setState({
                  diagnosedWithhearLoss: item.value,
                });
              }
              if (
                item.field ==
                "Have you ever received therapy to improve your speech?"
              ) {
                this.setState({
                  receivedTheoropy: item.value,
                });
              }
              if (item.field == "Do any of the following apply to you?") {
                this.setState({
                  applyToYou: item.value,
                });
              }
              if (item.field == "Do you have a cold right now?") {
                this.setState({
                  coldNow: item.value,
                });
              }
              if (
                item.field == "Have you been hospitalized in the past 3 months?"
              ) {
                this.setState({
                  hospitalizedInLast3month: item.value,
                });
              }
              if (
                item.field ==
                "What type of shoes will you be wearing for the entire duration of the study? "
              ) {
                this.setState({
                  typeOfShoes: item.value,
                });
              }
              if (item.field == "What type of Orthotics do you use?") {
                if (item.value != "") {
                  let temp = JSON.parse(item.value);
                  this.setState({
                    typeOfOrthoticsList: temp,
                  });
                }
              }
              if (item.field == "Please specify the dimensions") {
                this.setState({ dimensions: item.value });
              }
              if (item.field == "Do you have stairs at home?") {
                this.setState({ haveStairAtHome: item.value });
              }
              if (item.field == "How are your stairs at your house?") {
                this.setState({ howStairsAre: item.value });
              }
              if (item.field == "What is the flooring of your stairs?") {
                this.setState({ flooringOfYourStairs: item.value });
              }
              if (item.field == "How many steps are there?") {
                this.setState({ howManySteps: item.value });
              }
              if (
                item.field.toLowerCase() ==
                "please measure the height of a step"
              ) {
                this.setState({ heightOfStep: item.value });
              }
            }
          }
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  onChangeSelect = (value, stateName) => {
    console.log("val", value);
    console.log("stateName", stateName);
    this.setState({
      [stateName]: value,
    });
    if (stateName == "race" && value != "Other") {
      this.setState({ raceOtherSpeicification: "" });
    }
    if (stateName == "diagnosis") {
      if (value != "ALS") {
        this.setState({ diagnosisALS: "" });
      }
      if (value != "Any other Neurologic diagnosis") {
        this.setState({ diagnosisOther: "" });
      }
    }
    if (stateName == "isEnglishLanguage" && value == "Yes") {
      this.setState({ otherLangage: "", otherInputLanguage: "" });
    }
    if (stateName == "otherLangage" && value != "Other") {
      this.setState({ otherInputLanguage: "" });
    }
    if (stateName == "highelLevelOfEducation" && value != "Other") {
      this.setState({ otherHighestEducation: "" });
    }
    if (stateName == "haveStairAtHome" && value == "No") {
      this.setState({
        howStairsAre: "",
        flooringOfYourStairs: "",
        howManySteps: "",
        heightOfStep: "",
      });
    }
    if (stateName == "positiveHistory" && value == "No") {
      this.setState({ positiveHistoryIfYesValue: "" });
    }
    if (stateName == "siteOfSymptomOnset" && value != "Bulbur") {
      this.setState({ siteOfSymptomOnsetForBulbar: "" });
    }
    if (stateName == "siteOfSymptomOnset" && value != "Limb") {
      this.setState({ siteOfSymptomOnsetForLimb: "" });
    }
    if (
      stateName == "siteOfSymptomOnset" &&
      value != "Other site of symptoms"
    ) {
      this.setState({ siteOfSymptomOnsetOtherSpecification: "" });
    }
    if (stateName == "residenceType" && value != "Other") {
      this.setState({ residenceOtherSpecification: "" });
    }
  };

  pushIntoAllergies = () => {
    if (!this.state.allergyText) {
      message.warning("Please enter the allergy name");
      return;
    }
    let arr = this.state.allergies;
    arr.push(this.state.allergyText);
    this.setState({ allergies: arr, allergyText: "" });
  };
  pushIntoPrescription = () => {
    if (!this.state.prescriptionText) {
      message.warning("Please enter the Prescription");
      return;
    }
    let arr = this.state.prescriptions;
    arr.push(this.state.prescriptionText);
    this.setState({ prescriptions: arr, prescriptionText: "" });
  };
  pushIntoOrthotics = () => {
    if (!this.state.typeOfOrthotics) {
      message.warning("Please enter the Orthotics.");
      return;
    }
    let arr = this.state.typeOfOrthoticsList;
    arr.push(this.state.typeOfOrthotics);
    this.setState({ typeOfOrthoticsList: arr, typeOfOrthotics: "" });
  };
  deleteOrtho = (item, index) => {
    let list = this.state.typeOfOrthoticsList;
    let arr = [];
    for (let i = 0; i < list.length; i++) {
      let single = list[i];
      if (single != item && i != index) {
        arr.push(single);
      }
    }
    this.setState({ typeOfOrthoticsList: arr });
  };
  deleteAllergy = (item, index) => {
    let list = this.state.allergies;
    let arr = [];
    for (let i = 0; i < list.length; i++) {
      let single = list[i];
      if (single != item && i != index) {
        arr.push(single);
      }
    }
    this.setState({ allergies: arr });
  };
  deletePrescription = (item, index) => {
    let list = this.state.prescriptions;
    let arr = [];
    for (let i = 0; i < list.length; i++) {
      let single = list[i];
      if (single != item && i != index) {
        arr.push(single);
      }
    }
    this.setState({ prescriptions: arr });
  };

  render() {
    return (
      <div>
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-lg-2"></div>
          <div
            style={{
              background: "rgb(245, 245, 245)",
            }}
            className="col-lg-10 ml-auto main-section add-user top-space new-submission"
          >
            <br />
            <a
              href="#!"
              onClick={() => window.history.back()}
              className="go-back"
            >
              <i className="fas fa-chevron-left"></i>
            </a>
            <div
              className="wrapper clearfix"
              style={{
                paddingTop: 0,
                marginTop: 15,
              }}
            >
              <div className="multisteps-form">
                <div className="row">
                  <div className="col-12 col-lg-12">
                    <div
                      className="wizard-content-form add-demographics-form"
                      style={{
                        margin: "105px 0 14px 0%",
                        background: "#fff",
                        padding: 15,
                      }}
                    >
                      <div className="wizard-form-field" style={{ margin: 0 }}>
                        <h3 className="user-profile-heading">
                          View Demographics
                        </h3>
                        <Spin spinning={this.state.loading}>
                          <div className="row mt-4" style={{ fontSize: 18 }}>
                            {" "}
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="font-weight-600 col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5">
                                  Marital Status:
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.maritalStatus
                                      ? this.state.maritalStatus
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="font-weight-600 col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5">
                                  Residence Type:
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.residenceType
                                      ? this.state.residenceType
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {this.state.residenceType == "Other" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label className="font-weight-600 col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5">
                                    Please specify (Residence Type):
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    <span>
                                      {this.state.residenceOtherSpecification
                                        ? this.state.residenceOtherSpecification
                                        : "---"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="font-weight-600 col-lg-5 col-6 col-sm-6 cl-md-6 col-xl-5 tt-capitalize">
                                  Physical Gender at Birth:
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.physicalGenderBirth
                                      ? this.state.physicalGenderBirth
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="font-weight-600 col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5">
                                  Race:
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.race ? this.state.race : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {this.state.race == "Other" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label
                                    className="font-weight-600 col-lg-5 tt-capitalize
                                  col-6 col-sm-6 cl-md-6 col-xl-5"
                                  >
                                    Please specify (Race):
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    <span>
                                      {this.state.raceOtherSpeicification
                                        ? this.state.raceOtherSpeicification
                                        : "---"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Ethnicity:
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.ethnicity
                                      ? this.state.ethnicity
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Is English your first language?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  {this.state.isEnglishLanguage
                                    ? this.state.isEnglishLanguage
                                    : "---"}
                                </div>
                              </div>
                            </div>
                            {this.state.isEnglishLanguage == "No" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                    If No
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    <span>
                                      {this.state.isEnglishLanguage
                                        ? this.state.isEnglishLanguage
                                        : "---"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.otherLangage == "Other" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                    Please specify
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    {this.state.otherInputLanguage
                                      ? this.state.otherInputLanguage
                                      : "---"}
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Which region in the United States do you{" "}
                                  <br /> consider yourself from?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.usRegion
                                      ? this.state.usRegion
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Highest level of Education
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  {this.state.highelLevelOfEducation
                                    ? this.state.highelLevelOfEducation
                                    : "---"}
                                </div>
                              </div>
                            </div>
                            {this.state.highelLevelOfEducation == "Other" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                    Other Highest Education
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    {this.state.otherHighestEducation
                                      ? this.state.otherHighestEducation
                                      : "---"}
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  What is your occupation?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  {this.state.occupation
                                    ? this.state.occupation
                                    : "---"}
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Total Household Income
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.totalHouseIncome
                                      ? this.state.totalHouseIncome
                                      : "0"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  What is your dominant hand?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  {this.state.dominantHand
                                    ? this.state.dominantHand
                                    : "---"}
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Height
                                </label>
                                <div className="row col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7">
                                  <div className="col-lg-6 col-6 col-sm-6 cl-md-6 col-xl-5">
                                    <label className="pr-10 font-weight-600">
                                      Height In Feet:
                                    </label>
                                    <span>
                                      {this.state.heightInFeet
                                        ? this.state.heightInFeet
                                        : "---"}
                                    </span>
                                  </div>
                                  <div className="col-lg-6 col-6 col-sm-6 cl-md-6 col-xl-5">
                                    <label className="pr-10 font-weight-600">
                                      Height In Inch:
                                    </label>
                                    <span>
                                      {this.state.heightInInch
                                        ? this.state.heightInInch
                                        : "---"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5  col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Weight
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.weight
                                      ? this.state.weight
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Smoking History
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.smokingHistory
                                      ? this.state.smokingHistory
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Have you quit smoking in the past year?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.haveQuiteSmoking
                                      ? this.state.haveQuiteSmoking
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10 pb-4">
                              <div className="form-group d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Please List Specific Allergies
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  {this.state.allergies.length > 0 && (
                                    <table>
                                      {this.state.allergies.length > 0 &&
                                        this.state.allergies.map(
                                          (item, index) => {
                                            return (
                                              <tr>
                                                <td
                                                  style={{
                                                    minWidth: 130,
                                                    border: "1px solid #807e7e",
                                                    paddingLeft: 5,
                                                  }}
                                                >
                                                  <li
                                                    style={{
                                                      fontSize: 18,
                                                      overflowWrap: "anywhere",
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      width: "100%",
                                                      alignTtems: "center",
                                                    }}
                                                  >
                                                    {item}
                                                  </li>
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                    </table>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10 pb-4">
                              <div className="form-group d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  What are your current prescriptions?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  {this.state.prescriptions.length > 0 && (
                                    <table>
                                      {this.state.prescriptions.length > 0 &&
                                        this.state.prescriptions.map(
                                          (item, index) => {
                                            return (
                                              <tr>
                                                <td
                                                  style={{
                                                    minWidth: 130,
                                                    border: "1px solid #807e7e",
                                                    paddingLeft: 5,
                                                  }}
                                                >
                                                  <li
                                                    style={{
                                                      fontSize: 18,
                                                      overflowWrap: "anywhere",
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      width: "100%",
                                                      alignTtems: "center",
                                                    }}
                                                  >
                                                    {item}
                                                  </li>
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                    </table>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex font-weight-600">
                                <label className="col-lg-5 tt-capitalize">
                                  Do you have a history of any of the following?
                                </label>
                              </div>
                            </div>
                            {DEMOGRAPHIC_SELECT_LIST.YES_NO_QUESTIONS.map(
                              (item, index) => {
                                return (
                                  <div className="col-lg-10" key={index}>
                                    <div className="form-group mb-4 d-flex row">
                                      <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                        {item.title}
                                      </label>
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                        <span>
                                          {this.state[item.stateName]
                                            ? this.state[item.stateName]
                                            : "---"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            )}
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Diagnosis
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.diagnosis
                                      ? this.state.diagnosis
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {this.state.diagnosis == "ALS" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label className="col-lg-5 col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                    ALS
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    <span>
                                      {this.state.diagnosisALS
                                        ? this.state.diagnosisALS
                                        : "---"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.diagnosis ==
                              "Any other Neurologic diagnosis" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                    Any other Neurologic diagnosis
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    <span>
                                      {this.state.diagnosisOther
                                        ? this.state.diagnosisOther
                                        : "---"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Your Neurologist or Physician name:
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.physicianName
                                      ? this.state.physicianName
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Clinic or Hospital name:
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.hospitalName
                                      ? this.state.hospitalName
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Clinic or Hospital city:
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.hospitalCity
                                      ? this.state.hospitalCity
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Date of Diagnosis &nbsp;
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.dateOfDiagnosis
                                      ? moment(
                                          this.state.dateOfDiagnosis
                                        ).format("MM/DD/YYYY")
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  C9ORF Mutation
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.c9orfMutatio
                                      ? this.state.c9orfMutatio
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Date of Symptom Onset &nbsp;
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.dateOfSymptom
                                      ? moment(this.state.dateOfSymptom).format(
                                          "MM/DD/YYYY"
                                        )
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Site of Symptom Onset
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.siteOfSymptomOnset
                                      ? this.state.siteOfSymptomOnset
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {this.state.siteOfSymptomOnset == "Bulbar" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label className="col-lg-5 col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                    Bulbar
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    <span>
                                      {this.state.siteOfSymptomOnsetForBulbar
                                        ? this.state.siteOfSymptomOnsetForBulbar
                                        : "---"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.siteOfSymptomOnset == "Limb" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label className="col-lg-5 col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                    Limb
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    <span>
                                      {this.state.siteOfSymptomOnsetForLimb
                                        ? this.state.siteOfSymptomOnsetForLimb
                                        : "---"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.siteOfSymptomOnset ==
                              "Other site of symptoms" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                    Please Specify
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    <span>
                                      {this.state
                                        .siteOfSymptomOnsetOtherSpecification
                                        ? this.state
                                            .siteOfSymptomOnsetOtherSpecification
                                        : "---"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Do you have a positive family history for ALS
                                  or any other neurodegenerative disease
                                  (Frontotemporal Dementia, Parkinson’s Disease,
                                  Altzheimer’s Disease)?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.positiveHistory
                                      ? this.state.positiveHistory
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {this.state.positiveHistory == "Yes" && (
                              <div className="col-lg-10">
                                <div className="form-group mb-4 d-flex row">
                                  <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                    {" "}
                                    If yes, please indicate the relationship
                                    (mother, father, sibling etc…), the disease,
                                    and the approximate age of onset of disease
                                    symptoms:
                                  </label>
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                    <span>
                                      {this.state.positiveHistoryIfYesValue
                                        ? this.state.positiveHistoryIfYesValue
                                        : "---"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  {" "}
                                  Have you been diagnosed with hearing loss?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.diagnosedWithhearLoss
                                      ? this.state.diagnosedWithhearLoss
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  {" "}
                                  Have you ever received therapy to improve your
                                  speech?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.receivedTheoropy
                                      ? this.state.receivedTheoropy
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Do any of the following apply to you?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.applyToYou
                                      ? this.state.applyToYou
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  {" "}
                                  Do you have a cold right now?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.coldNow
                                      ? this.state.coldNow
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  {" "}
                                  Have you been hospitalized in the past 3
                                  months?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.hospitalizedInLast3month
                                      ? this.state.hospitalizedInLast3month
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  {" "}
                                  What type of shoes will you be wearing for the
                                  entire duration of the study?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.typeOfShoes
                                      ? this.state.typeOfShoes
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10 pb-3">
                              <div className="form-group d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  {" "}
                                  What type of Orthotics do you use?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  {this.state.typeOfOrthoticsList.length >
                                    0 && (
                                    <table>
                                      {this.state.typeOfOrthoticsList.length >
                                        0 &&
                                        this.state.typeOfOrthoticsList.map(
                                          (item, index) => {
                                            return (
                                              <tr>
                                                <td
                                                  style={{
                                                    minWidth: 130,
                                                    border: "1px solid #807e7e",
                                                    paddingLeft: 7,
                                                  }}
                                                >
                                                  <li
                                                    style={{
                                                      fontSize: 18,
                                                      overflowWrap: "anywhere",
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      width: "100%",
                                                      alignTtems: "center",
                                                    }}
                                                  >
                                                    {item}
                                                  </li>
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                    </table>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  {" "}
                                  Please specify the dimensions:
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.dimensions
                                      ? this.state.dimensions
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div className="form-group mb-4 d-flex row">
                                <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                  Do you have stairs at home?
                                </label>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                  <span>
                                    {this.state.haveStairAtHome
                                      ? this.state.haveStairAtHome
                                      : "---"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {this.state.haveStairAtHome == "Yes" && (
                              <>
                                <div className="col-lg-10">
                                  <div className="form-group mb-4 d-flex row">
                                    <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                      How are your stairs at your house?
                                    </label>{" "}
                                    <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                      <span>
                                        {this.state.howStairsAre
                                          ? this.state.howStairsAre
                                          : "---"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-10">
                                  <div className="form-group mb-4 d-flex row">
                                    <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                      What is the flooring of your stairs?
                                    </label>{" "}
                                    <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                      <span>
                                        {this.state.flooringOfYourStairs
                                          ? this.state.flooringOfYourStairs
                                          : "---"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-10">
                                  <div className="form-group mb-4 d-flex row">
                                    <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                      {" "}
                                      How many steps are there?
                                    </label>{" "}
                                    <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                      <span>
                                        {this.state.howManySteps
                                          ? this.state.howManySteps
                                          : "---"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-10">
                                  <div className="form-group mb-4 d-flex row">
                                    <label className="col-lg-5 tt-capitalize col-6 col-sm-6 cl-md-6 col-xl-5 font-weight-600">
                                      Please measure the height of a step:
                                    </label>
                                    <div className="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                                      <span>
                                        {this.state.heightOfStep
                                          ? this.state.heightOfStep
                                          : "---"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </Spin>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ViewDemographics;
